import './Header.css';
import type { FunctionComponent } from 'react';
import classNames from 'classnames';
import { getLogoImage } from '@fff-web/fff-utilities';

export type NMFHeaderContentProps = {
  env: { name: string };
};

const NMFHeaderContent: FunctionComponent<NMFHeaderContentProps> = ({ env }) => (
  <div className={classNames('header__content')} data-testid="nmf_header">
    <span className="fff-logo">
      <img src={getLogoImage(env?.name)} alt="logo" />
    </span>
  </div>
);

export default NMFHeaderContent;
